
















































import Vue from 'vue'
export default Vue.extend({
  computed: {
    topupScreen: {
      get() {
        return localStorage.getItem('topupScreen') === 'true'
      },
      set(value: boolean) {
        localStorage.setItem('topupScreen', String(value))
      },
    },
    remittanceScreen: {
      get() {
        return localStorage.getItem('remittanceScreen') === 'true'
      },
      set(value: boolean) {
        localStorage.setItem('remittanceScreen', String(value))
      },
    },
  },
  methods: {
    onChangeDark(value: boolean) {
      localStorage.setItem('darkMode', String(value))
    },
  },
})
